module.exports = __webpack_public_path__ + "img/wibo-12.02012ad8.jpg";